import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const AddCoupons = () => {
  const [userType, setUserType] = useState("");
  const [couponCode, setCouponCode] = useState("");
  const [couponValue, setCouponValue] = useState();
  const [status, setStatus] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [limit, setLimit] = useState();
  const [expireDate, setExpireDate] = useState("");

  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  const [category, setCategory] = useState([]);
  const [selectCategory, setSelectCategory] = useState("");

  // Get today's date in 'YYYY-MM-DD' format
  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Add leading zero
    const day = String(today.getDate()).padStart(2, "0"); // Add leading zero
    return `${year}-${month}-${day}`;
  };

  const handleAddCategory = () => {
    if (selectCategory && !category.includes(selectCategory)) {
      setCategory([...category, selectCategory]);
      setSelectCategory(""); // reset dropdown
    }
  };

  const handleRemoveCategory = (cat) => {
    setCategory(category.filter((item) => item !== cat));
  };

  const handleAddNewCoupons = () => {
    navigate("/add-coupons");
  };

  const handleViewAllCoupons = () => {
    navigate("/all-coupons");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const couponData = {
      userType,
      couponCode,
      status,
      value: couponValue,
      limit,
      expiryDate: expireDate,
      category,
    };

    try {
      const response = await axios.post(
        `${API_BASE_URL}/admin/coupons`,
        couponData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      alert("Coupon added successfully!");
      navigate("/all-coupons");
    } catch (error) {
      console.error("Error adding coupon:", error.response?.data?.msg);
      alert("Failed to add coupon. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div id="add-subject-inner-wrapper">
        <div className="superheader">
          <div className="subjectHeaderdiv">
            <h5>Offer And Coupons</h5>
            <div className="subjectdiv2">
              <button
                className="handleNewSubject"
                onClick={handleAddNewCoupons}
              >
                + Add New Coupon
              </button>
              <button className="allSubjects" onClick={handleViewAllCoupons}>
                All Coupon
              </button>
            </div>
          </div>

          <div className="form-sub-container mt-4" id="form">
            <h4 className="subject-detail">Coupons Details</h4>
            <form
              className="subject-detail-form"
              encType="multipart/form-data"
              onSubmit={handleSubmit}
            >
              <div className="input-group">
                <div style={{ paddingBottom: "10px" }}>
                  <label className="label">User Type</label>
                </div>
                <select
                  className="select-dropdown"
                  value={userType}
                  onChange={(e) => setUserType(e.target.value)}
                  required
                >
                  <option value="">-Select User Type-</option>
                  <option value="Student">Student</option>
                  <option value="Teacher">Teacher</option>
                  <option value="Both">Both</option>
                </select>
              </div>

              <div className="input-group">
                <div style={{ paddingBottom: "10px" }}>
                  <label className="label">Coupon Code</label>
                </div>
                <input
                  type="text"
                  placeholder="Enter Coupon Code"
                  value={couponCode}
                  onChange={(e) => setCouponCode(e.target.value)}
                  required
                />
              </div>

              <div className="input-group">
                <div style={{ paddingBottom: "10px" }}>
                  <label className="label">Coupon Value %</label>
                </div>
                <input
                  type="text"
                  placeholder="Enter Coupon Value in %"
                  value={couponValue}
                  onChange={(e) => setCouponValue(e.target.value)}
                  required
                />
              </div>

              <div className="input-group">
                <div style={{ paddingBottom: "10px" }}>
                  <label className="label">Coupon usages limit</label>
                </div>
                <input
                  type="text"
                  placeholder="Enter Limit"
                  value={limit}
                  onChange={(e) => setLimit(e.target.value)}
                  required
                />
              </div>

              <div className="input-group">
                <div style={{ paddingBottom: "10px" }}>
                  <label className="label">Expire Date</label>
                </div>
                <input
                  type="date"
                  placeholder="Enter Date"
                  value={expireDate}
                  onChange={(e) => setExpireDate(e.target.value)}
                  min={getTodayDate()} // Disable past dates
                  required
                />
              </div>

              <div className="input-group">
                <div style={{ paddingBottom: "10px" }}>
                  <label className="label">Status</label>
                </div>
                <select
                  className="select-dropdown"
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                  required
                >
                  <option value="">-Select Status-</option>
                  <option value="active">Active</option>
                  <option value="inactive">InActive</option>
                </select>
              </div>

              <div className="input-group">
                <div style={{ paddingBottom: "10px" }}>
                  <label className="label">Select Category</label>
                </div>
                <div style={{ display: "flex", gap: "10px" }}>
                  <select
                    className="school-class-add-input-tag"
                    value={selectCategory}
                    onChange={(e) => setSelectCategory(e.target.value)}
                  >
                    <option value="">-Select Category-</option>
                    <option
                      value="Home_Work"
                      disabled={category.includes("Home_Work")}
                    >
                      Home Work
                    </option>
                    <option
                      value="Exam_Notes"
                      disabled={category.includes("Exam_Notes")}
                    >
                      Exam Notes
                    </option>
                    <option
                      value="Subjective_Exam"
                      disabled={category.includes("Subjective_Exam")}
                    >
                      Subjective Exam
                    </option>
                    <option
                      value="Assignment"
                      disabled={category.includes("Assignment")}
                    >
                      Assignment
                    </option>
                    <option
                      value="Appointment"
                      disabled={category.includes("Appointment")}
                    >
                      Appointment
                    </option>
                    <option
                      value="English_Course"
                      disabled={category.includes("English_Course")}
                    >
                      English Course
                    </option>
                  </select>
                  <button
                    type="button"
                    onClick={handleAddCategory}
                    className="btn-s"
                  >
                    Add
                  </button>
                </div>
              </div>

              {/* Show selected categories with remove option */}
              {category.length > 0 && (
                <div className="selected-categories">
                  <p style={{ marginBottom: "5px" }}>Selected Categories:</p>
                  <ul>
                    {category.map((cat, index) => (
                      <li key={index} style={{ marginBottom: "5px" }}>
                        {cat.replaceAll("_", " ")}
                        <button
                          type="button"
                          onClick={() => handleRemoveCategory(cat)}
                          style={{
                            marginLeft: "10px",
                            background: "red",
                            color: "white",
                            border: "none",
                            padding: "2px 6px",
                            borderRadius: "4px",
                            cursor: "pointer",
                          }}
                        >
                          Remove
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              <div className="school-subj-form-btns">
                <button
                  className="btn-search"
                  type="submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Saving..." : "Save"}
                </button>
                <button
                  className="btn-cancel"
                  type="button"
                  onClick={() => navigate("/all-coupons")}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddCoupons;
